import { render } from "./SentModal.vue?vue&type=template&id=4ac27f9f"
import script from "./SentModal.vue?vue&type=script&lang=js"
export * from "./SentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__